// @flow
import NumberFormat from 'react-number-format';

type PropsType = {
  active: boolean,
  completed: boolean,
  onSubmitClick: () => void,
  cartTotal: number,
  submissionErrors: ?string
};

export default ({
  active,
  completed,
  onSubmitClick,
  cartTotal,
  submissionErrors
}: PropsType) => {
  return (
    <div id='checkoutBox'>
      <h3>Order Review:</h3>
      <div id='checkoutContent'>
        <div
          id='confirm_checkout'
          style={{ display: active ? 'flex' : 'none' }}
          className='clearfix'
        >
          <dl>
            <dt>
              <label htmlFor='order_comments'>Comments:</label>
            </dt>
            <dd>
              <textarea
                cols={40}
                id='order_comments'
                name='order[comments]'
                rows={20}
                defaultValue={''}
              />
              <p />
            </dd>
            <dd>
              <input
                className='blue button'
                defaultValue='Place Order'
                type='button'
                style={{ cursor: 'pointer' }}
                onClick={onSubmitClick}
              />
            </dd>
            <dd>
              <div className='checkoutErrors'>{submissionErrors}</div>
            </dd>
          </dl>
          <div>
            <h2 style={{ textTransform: 'none', marginBottom: 20 }}>
              The amount your card will be charged is{' '}
              <strong className='blue grandTotal'>
                <NumberFormat
                  value={cartTotal}
                  displayType={'text'}
                  thousandSeparator
                  fixedDecimalScale
                  prefix={'$'}
                  decimalScale={2}
                />
              </strong>
            </h2>
            Please share any comments or special instructions in the field
            provided.
          </div>
        </div>
      </div>
    </div>
  );
};
